var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxboldclipboardTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.7,2c-1,0-1.9,0.8-1.9,1.9v0.9c0,1,0.8,1.9,1.9,1.9h4.7c1,0,1.9-0.8,1.9-1.9V3.9 c0-1-0.8-1.9-1.9-1.9H9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3,4.2c-0.5-0.3-1.1,0.1-1.1,0.7c0,1.6-1.3,2.9-2.9,2.9h-3.9H9.6C8,7.8,6.7,6.5,6.7,4.9 c0-0.6-0.6-0.9-1.1-0.7C4.2,5,3.2,6.4,3.2,8.2v2.2v7.2c0,2.5,2,4.5,4.5,4.5h5.7c0.5,0,1-0.5,1-1v-3.5c0-1.7,1.3-3,3-3h3 c0.1,0,0.1,0,0.2,0V8.1C20.7,6.4,19.7,4.9,18.3,4.2z M12.4,16.9H8c-0.4,0-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8h4.4 c0.4,0,0.8,0.3,0.8,0.8C13.1,16.6,12.8,16.9,12.4,16.9z M15,12.9H8c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8h7 c0.4,0,0.8,0.3,0.8,0.8S15.4,12.9,15,12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,23c1.3,0,2-0.8,2-2v-3c0-1.3-0.8-2-2-2h-3c-1.3,0-2,0.8-2,2v3c0,1.3,0.8,2,2,2H21z M19.3,21.2 c-0.2,0.2-0.3,0.2-0.5,0.2s-0.4-0.1-0.5-0.2l-0.8-0.8c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0l0.2,0.2l1.7-1.7 c0.3-0.3,0.8-0.3,1.1,0c0.3,0.3,0.3,0.8,0,1.1L19.3,21.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxboldclipboardTask);
export default __webpack_public_path__ + "static/media/vuesaxboldclipboard-task.0b3ca816293cb0869787d8077c8dfa61.svg";
export { ForwardRef as ReactComponent };